import React, { useEffect, useState } from "react";
import Attributes  from "../Drawers/Attributes";
import styled from "styled-components";
import Visualizer from "../Visualizer/Visualizer";
import { useDispatch, useSelector } from "react-redux";
import { ProjectActions } from "../../reducers/project/actionsNames";
import { RouteComponentProps, useHistory } from "react-router";
import {
    getCurrentProject,
    getLoaded,
    getSelectedAttributes,
} from "../../reducers/project/selectors";
import content from "../../content";
import { ChevronRight } from "@material-ui/icons";
import Toolbar from "../Visualizer/Toolbar";
import { AttributesType, IProject } from "../../reducers/project";
import { useFetch } from "../../hooks/useFetch";
import addProjectToCart from "../../actions/project/addProjectToCart";
import useDesktop  from "../../components/Responsive/useDesktop";
import Renderer from "../Visualizer/Renderer";

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const PriceWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px;
  height: 72px;
  background: #ffffff;
  border-radius: 4px 4px 0px 0px;
  color: black;
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  margin: 0 30px;
  user-select: none;
  line-height: 26px;
  /* identical to box height, or 171% */

  letter-spacing: -0.01em;
`;

export const Price = ({ anyPrice }: any) => {
    const selected = useSelector(getSelectedAttributes);

    return (
        <PriceWrapper>
            <div>{content.getValue("cost")}</div>
            <div style={{ color: "#1B576A" }}>
                {anyPrice !== undefined
                    ? anyPrice
                    : selected.reduce((a, b) => a + Number(b.price), 0)}{" "}
                {content.getValue("price_surfix")}
            </div>
        </PriceWrapper>
    );
};

const ButtonWrapper = styled.div<any>`
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  background-color: ${({ disabled }) => (disabled ? "#91adb8" : "#1b576a")};
  border-radius: 0px 0px 4px 4px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  cursor: pointer;
  font-size: 18px;
  margin: 0 30px;
  user-select: none;
  letter-spacing: -0.01em;
`;

export const Button = ({ onClick = () => {}, label, disabled }: any) => {
    return (
        <ButtonWrapper onClick={disabled ? undefined : onClick} disabled={disabled}>
            {label || content.getValue("add_to_cart")} <ChevronRight />
        </ButtonWrapper>
    );
};

function Creator({ match }: ICreator) {
    const [openDrawer, setOpen] = useState(false);
    const [attribute, setAttr] = useState({});
    const dispatch = useDispatch();
    const loaded = useSelector(getLoaded);
    const project = useSelector(getCurrentProject);
    const history = useHistory();
    const dekstop = useDesktop();
    const [responseProject, requestProject] = useFetch<IProject>(
        "/project/",
        {} as any,
        { method: "GET", body: null }
    );

    useEffect(() => {
        if (match.params?.id && !loaded) {
            requestProject({}, match.params?.id).then((data) => {
                if (data) {
                    dispatch({ type: ProjectActions.SetLoaded, loaded: true });

                    dispatch({ type: ProjectActions.LoadProject, project: data });
                }
            });
        }
    }, [loaded]);

    useEffect(() => {
        dispatch({
            type: ProjectActions.FetchAttributes,
            ignoreDefault: match.params?.id && !loaded,
        });
    }, []);

    const createProject = () => {
        dispatch({ type: ProjectActions.CreateProject });
    };

    useEffect(() => {
        if (match.params?.id) {
            dispatch({ type: ProjectActions.FetchProject, id: match.params?.id });
        }
    }, []);

    const onclik = (a) => {
        setAttr(a);
        setOpen(true);
    };

    const addProject = () => {
        dispatch(
            addProjectToCart({
                ...project,
                count:
                    project?.components.find((c) => c.category === AttributesType.Count)
                        ?.value || 1,
            })
        );
        history.push("/cart");
    };

    return (
        <>
            <Attributes addProject={addProject} onClick={onclik} />

            {dekstop && (
                <div
                    style={{
                        margin: "20px 20px 0px",
                        border: "1px solid #f1f1f1",
                        width: "75%",
                        backgroundColor: "#fafafa",
                    }}
                >
                    {/*<Visualizer />*/}
                    <Renderer/>
                    {/*<Toolbar />*/}
                    <Price />
                    {/*<Button onClick={addProject} />*/}
                </div>
            )}
        </>
    );
}

export interface ICreator extends RouteComponentProps<{ id?: string }> {}

export default Creator;
